import CustomStarRating from './CustomStarRating';

export default CustomStarRating;
